import type { OcpsPolicyFeature, FeatureSettingIdMap } from './OutlookCloudPolicyTypes';

export enum OcpsPoliciesFetchState {
    NotStarted,
    Fetching,
    Succeeded,
    Failed,
}

export interface OutlookCloudPolicyData {
    value: string;
    valueName: string;
    type: string;
}

export type AccountOcpsPolicies = {
    [F in OcpsPolicyFeature]?: Partial<Record<FeatureSettingIdMap[F], OutlookCloudPolicyData>>;
};

export interface AccountOcpsPoliciesState {
    policies: AccountOcpsPolicies;
    fetchState: OcpsPoliciesFetchState;
}
